module.exports = __webpack_public_path__ + "img/logo-icon.b29675cc.png";